export const getCupsSearchByCups = (state) => state.cupsSearcher.byCups
